import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "inherit", fillRule: "evenodd", d: "m6,7.667l-6,-6l1.4,-1.4l4.6,4.6l4.6,-4.6l1.4,1.4l-6,6z" }));
export default SvgChevronDown;
